<template>
    <div name="contact" class="contact">
        <span class="c-title">솔닥과 제휴하고<br/>파트너가 되어주세요</span>
        <span class="c-sub-title">솔닥과 함께 헬스케어의 새 흐름을 만들어 갈<br/>파트너 병원과 약국을 모집합니다.</span>
        <a href="https://soldoc.co.kr/partners" class="c-contact-btn" target="_blank" title="새창으로 열림">제휴 신청 바로가기</a>
    </div>
</template>

<script>
export default {
    name: 'contact',
    mounted: function()
    {
		$(window).scroll(function () {
            var height = $(document).scrollTop();
            var contTop = $('.contact').offset().top;

            var contHeight = height - contTop;
            var winHeight = $(window).height();
            var acviveHeight = contHeight + winHeight;
            // console.log(acviveHeight);
            
            if(acviveHeight < 70 && acviveHeight <= 170)
            {
				$('.contact .c-title').css('display', `inline-block`);
                $('.contact .c-sub-title').css('display', `inline-block`);
                $('.contact .c-contact-btn').css('display', `flex`);
            } else if(acviveHeight > 170)
            {
				$('.contact .c-title').css('display', `inline-block`);
                $('.contact .c-sub-title').css('display', `inline-block`);
                $('.contact .c-contact-btn').css('display', `flex`);
            } 
        })
    },
    methods: {
    }
}
</script>

<style scoped>
 	.contact {
		background-image: url('../../assets/renew_mobile/bg_contact_banner.jpg');
		width: 100%;
		height: 720px;
		background-size: cover;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-direction: column;
		padding-top: 82px;
	}
	.c-title{
		font-weight: 600;
		font-size: 32px;
		line-height: 44px;
		text-align: center;
		color: #fff;
		display: none;
		animation: fadeInUp 1s;
	}
	.c-sub-title{
		display: none;
		margin-top: 19px;
		font-weight: 400;
		font-size: 16px;
		line-height: 30px;
		text-align: center;
		color: #fff;
		line-height: 1.6;
		animation: fadeInUp1 1s;
	}
	.c-contact-btn{
		width: 200px;
		height: 50.19px;
		margin-top: 36px;
		background: #008DEF;
		border-radius: 6px;
		font-weight: 500;
		font-size: 18px;
		line-height: 64px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		color: #fff;
		display: none;
		animation: fadeInUp1 1s;
		text-decoration: none;
	}
	.c-contact-btn:hover, .c-contact-btn:focus, .c-contact-btn:active{
		background: #fff;
		color: #008DEF;
	}
    @media screen and (max-width: 360px){
        .contact {
			background-image: url('../../assets/renew_mobile/bg_contact_banner.jpg');
            width: 100%;
            height: 484px;
            background-size: cover;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            padding-top: 55px;
        }
        .c-title{
            font-weight: 600;
            font-size: 23px;
            line-height: 30px;
            text-align: center;
            color: #FFFFFF;
            display: none;
            animation: fadeInUp 1s;
        }
        .c-sub-title{
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            color: #FFFFFF;
            margin-top: 12px;
            display: none;
            animation: fadeInUp1 1s;
        }
        .c-contact-btn{
            width: 135px;
            height: 34.75px;
            border-radius: 6px;
            font-weight: 500;
            font-size: 12px;
            line-height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            margin-top: 18px;
            display: none;
            animation: fadeInUp1 1s;
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/Contact.vue